import styled from 'styled-components'
import { backgroundOrange, darkOrange, gold, danger, black, textMuted } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { Button } from '@components/Button'
import { Input } from '@components/Field'

/** The shared form kit (Field + Button primitives) — one copy for every modal. */
export { Button, ButtonGroup, FormGroup, FormInput, FormLabel } from '@pages/Itinerary/AddEventModal/FormComponents.styles'

export const AmountInputWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
`

export const AmountPrefix = styled.span`
	position: absolute;
	left: 16px;
	font-size: ${fontSizes.body};
	color: ${textMuted};
	pointer-events: none;
`

export const AmountInput = styled(Input)`
	padding-left: 32px;
	-moz-appearance: textfield;

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`

export const StepIndicator = styled.div`
	${text.eyebrow}
	color: ${gold};
	margin-bottom: 20px;
`

export const StepHeading = styled.h3`
	${text.title}
	color: ${darkOrange};
	margin: 0 0 20px 0;
`

export const BackButton = styled(Button).attrs({ variant: 'ghost' as const, size: 'sm' as const })`
	padding-left: 0;
	margin-bottom: 16px;
`

export const MemberList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`


export const MemberName = styled.span`
	font-size: ${fontSizes.base};
	font-weight: 500;
	color: ${black};
	flex: 1;
`

export const PayerRecipientRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
	padding: 20px;
	background: ${backgroundOrange};
	border-radius: ${radii.inner};
	margin-bottom: 24px;
`

export const PayerRecipientPerson = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
`

export const PayerRecipientLabel = styled.span`
	${text.eyebrow}
	color: ${textMuted};
`

export const PayerRecipientName = styled.span`
	font-size: ${fontSizes.small};
	font-weight: 500;
	color: ${black};
`

export const PayerRecipientArrow = styled.div`
	color: ${darkOrange};
	font-size: ${fontSizes.headingLg};
	font-weight: 700;
`

export const ValidationError = styled.div`
	font-size: ${fontSizes.caption};
	color: ${danger};
	margin-top: 6px;
`

export const SoftWarning = styled.div`
	font-size: ${fontSizes.caption};
	color: ${gold};
	background: ${gold}1f;
	padding: 8px 12px;
	border-radius: ${radii.small};
	margin-top: 8px;
`

export const ThirdPartyNotice = styled.div`
	font-size: ${fontSizes.micro};
	text-align: center;
	font-style: italic;
	margin-top: 16px;
	line-height: ${leading.body};
`
